import { Clock } from "lucide-react";

const hours = [
  { day: "Montag", time: "08:00 – 17:00" },
  { day: "Dienstag", time: "08:00 – 17:00" },
  { day: "Mittwoch", time: "08:00 – 17:00" },
  { day: "Donnerstag", time: "08:00 – 17:00" },
  { day: "Freitag", time: "08:00 – 17:00" },
  { day: "Samstag", time: "08:00 – 12:00" },
  { day: "Sonntag", time: "Geschlossen" },
];

export const OpeningHours = () => {
  return (
    <section className="section-pad bg-background">
      <div className="container-narrow">
        <div className="mb-12 text-center">
          <span className="eyebrow text-secondary">Erreichbarkeit</span>
          <h2 className="h2-display mt-3 text-primary">Öffnungszeiten</h2>
          <span className="gold-underline" />
          <p className="mx-auto mt-6 max-w-2xl body-base text-muted-foreground">
            Wir sind sechs Tage die Woche für Sie da. Außerhalb der Bürozeiten
            erreichen Sie uns gerne per E-Mail oder über unser Kontaktformular —
            wir melden uns schnellstmöglich zurück.
          </p>
        </div>

        <div className="mx-auto max-w-2xl rounded-xl bg-card p-8 shadow-card">
          <div className="mb-6 flex items-center gap-3">
            <div
              className="flex h-12 w-12 items-center justify-center rounded-lg"
              style={{ background: "rgba(45,106,79,0.1)" }}
            >
              <Clock className="h-6 w-6 text-secondary" />
            </div>
            <div>
              <h3 className="h3-display text-primary">Wann wir für Sie da sind</h3>
              <p className="text-sm text-muted-foreground">Murtal & Umgebung</p>
            </div>
          </div>

          <ul className="divide-y divide-border">
            {hours.map((h) => (
              <li key={h.day} className="flex items-center justify-between py-3">
                <span className="font-medium text-foreground">{h.day}</span>
                <span className="text-muted-foreground">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
